<template>
    <input :id="id" :type="type" :placeholder="placeholder" :value="modelValue" @input="updateValue"
        :class="inputClass" />
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
    props: {
        id: { type: String, required: true },
        type: { type: String, default: 'text' },
        placeholder: { type: String, default: '' },
        modelValue: { type: String }
    },
    emits: ['update:modelValue'], // Poprawnie zdefiniowane emitowanie zdarzeń
    setup(props, { emit }) {
        const inputClass = computed(() => 'form-control');

        const updateValue = (event: Event) => {
            emit('update:modelValue', (event.target as HTMLInputElement).value);
        };

        return { inputClass, updateValue };
    }
});
</script>